module.exports = {
  object: require('./object'),
  array: require('./array'),
  regex: require('./regexp')
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/badwords-list/lib/index.js
 ** module id = 2414
 ** module chunks = 0
 **/